import { DroneEntity } from '@src/core/features';
import { SetURLSearchParams } from 'react-router-dom';
import { orderFeatureApi } from '@src/features/order/redux/api';
import {
  addEndedMissionSerial,
  removeOptimisticMissionSerials,
  setSelectedDrone,
} from '@src/features/drone/redux/actions';
import { refetchDronesCache } from '@src/features/drone/utils/refetch-drones-cache';
import type { AppDispatch } from '@src/store';

/** Drop mission/order route params while keeping the selected drone on the map. */
export function clearMissionRouteContext(
  dispatch: AppDispatch,
  setSearchParams: SetURLSearchParams,
  currentParams: URLSearchParams,
  drone?: DroneEntity | null,
): void {
  if (drone) {
    // Mission ended for this drone: drop its optimistic flag, mark it as ended so its route is
    // suppressed and it reads as IDLE even while the list still lags on MISSION, and optimistically
    // clear the mission/order on it. refreshAfterMissionEnded refetches; once REST confirms IDLE the
    // ended flag is dropped (useDronesPageViewModel), so suppression never sticks.
    dispatch(removeOptimisticMissionSerials([drone.serialNumber]));
    dispatch(addEndedMissionSerial(drone.serialNumber));
    dispatch(
      setSelectedDrone({
        ...drone,
        missionId: undefined,
        currentOrderId: undefined,
      }),
    );
  }

  const next = new URLSearchParams(currentParams);
  next.delete('missionId');
  next.delete('orderId');
  setSearchParams(next, { replace: true });
}

export function refreshAfterMissionEnded(dispatch: AppDispatch): void {
  refetchDronesCache(dispatch);
  dispatch(orderFeatureApi.util.invalidateTags(['OrderDetails']));
}
